<!-- nå i kompakt modus utelates visse celler og grid-layouten er definert annerledes (se ../saksliste/saksliste.scss) -->

@if (sak().erPause) {
  <span class="tittel-linje">
    <span class="nummer" data-testid="nummer" [scrollTilSynlig]="erAktiv()" [scrollTilSynligVedEndringAv]="holdSynligVedEndringAv()"></span>
    <span class="tittel" data-testid="tittel">{{ sak().tittel }}</span>
    @if (!kompakt()) {
      <span class="ansvarlig"></span>
      <span class="handlinger">
        <button mat-icon-button (click)="gaaTilSaksdetaljer()" [disabled]="sorteringAktivert()">
          <mat-icon fontSet="ion-ios-arrow-thin-right" class="mat-icon--ionic-ikon"/>
        </button>
      </span>
    }
  </span>
  <span class="detaljer-linje">
    <ng-container *ngTemplateOutlet="sorteringFragment"/>
    <ng-container *ngTemplateOutlet="tidFragment"/>
  </span>

} @else {
  <!-- sak -->
  <h2 class="tittel-linje">
    <span class="nummer" data-testid="nummer" [scrollTilSynlig]="erAktiv()" [scrollTilSynligVedEndringAv]="holdSynligVedEndringAv()">
      {{ sak().nummer }}
      @if (erFavoritt()) {
        <mat-icon fontSet="ion-ios-star" class="favoritt mat-icon--ionic-ikon"/>
      }
    </span>
    <span class="tittel" data-testid="tittel">{{ sak().tittel }}</span>
    @if (!kompakt()) {
      <span class="ansvarlig" data-testid="ansvarlig">
        <avatar [medlem]="sak().ansvarlig"/>
      </span>
      <span class="handlinger ikke-print">
        <button mat-icon-button (click)="gaaTilSaksdetaljer()" [disabled]="sorteringAktivert()">
          <mat-icon fontSet="ion-ios-arrow-thin-right" class="mat-icon--ionic-ikon"/>
        </button>
      </span>
    }
  </h2>

  <span class="detaljer-linje">
    <ng-container *ngTemplateOutlet="sorteringFragment"/>
    <ng-container *ngTemplateOutlet="tidFragment"/>
    @if (!kompakt()) {
      <!-- pakker tittel-verdi inn i span for at bakgrunnsfarge ved aktiv sak skal bli heldekkende (tittel-verdi har margin) -->
      <span class="sakstype" data-testid="sakstype">
        <tittel-verdi tittel="{{'Sakstype'|translate}}" [verdi]="sak().sakstype?.navn ?? '-'" stil="horisontal--en-linje"/>
      </span>
      <span class="tema" data-testid="tema">
        <tittel-verdi tittel="{{'Tema'|translate}}" [verdi]=" sak().tema?.navn ?? '-'" stil="horisontal--en-linje"/>
      </span>
    }
    <span class="dokumenter" [matTooltip]="antallDokumenter().antallUleste > 0 ? ('Du har {antall} uleste dokumenter'|translate : {antall: antallDokumenter().antallUleste}) : 'Antall dokumenter' ">
      <tittel-verdi stil="horisontal--en-linje" [class.tom-teller]="antallDokumenter().antallTotalt == 0" [class.ingen-uleste]="antallDokumenter().antallUleste == 0">
        <tittel>
          <ikon-med-teller [teller]="antallDokumenter().antallUleste" skjulTellerDersomNull="true" fontSet="lederplan-ikon-dokument" class="mat-icon--lederplan-ikon"/>
        </tittel>
        <verdi>{{ antallDokumenter().antallTotalt }}</verdi>
      </tittel-verdi>
    </span>
    @if (!kompakt()) {
      <span class="oppgaver"
            [matTooltip]="antallOppgaver().antallForfalt > 0 ? ('{antall} oppgaver er forfalt'|translate : {antall: antallOppgaver().antallForfalt}) : 'Antall oppgaver' ">
        <tittel-verdi stil="horisontal--en-linje" [class.tom-teller]="antallOppgaver().antallTotalt == 0">
          <tittel>
            <ikon-med-teller [teller]="antallOppgaver().antallForfalt" skjulTellerDersomNull="true" fontSet="lederplan-ikon-oppgave" class="mat-icon--lederplan-ikon"/>
          </tittel>
          <verdi>{{ antallOppgaver().antallTotalt }}</verdi>
        </tittel-verdi>
      </span>
      <span class="beslutninger" matTooltip="{{'Antall beslutninger'|translate}}">
        <tittel-verdi stil="horisontal--en-linje" [class.tom-teller]="antallBeslutninger() == 0">
          <tittel>
            <mat-icon fontSet="lederplan-ikon-beslutning" class="mat-icon--lederplan-ikon"/>
          </tittel>
          <verdi>{{ antallBeslutninger() }}</verdi>
        </tittel-verdi>
      </span>
      <span class="kommentarer" matTooltip="{{'Antall kommentarer'|translate}}">
        <tittel-verdi stil="horisontal--en-linje" [class.tom-teller]="antallKommentarer() == 0">
          <tittel>
            <mat-icon fontSet="ion-ios-chatbubble-outline" class="mat-icon--ionic-ikon"/>
          </tittel>
          <verdi>{{ antallKommentarer() }}</verdi>
        </tittel-verdi>
      </span>
    }
  </span>
}

<ng-template #sorteringFragment>
  <div class="sakssortering-kontainer ikke-print" cdkDragHandle data-testid="sakssortering-kontainer">
    <!-- deaktivering av cdkDrag skjer i SakslisteKomponent, her må vi bare sørge for at .sortering-handlinger ikke vises  -->
    @if (!utenSortering()) {
      <div class="sortering-handlinger">
        <mat-icon class="opp" (click.stopp)="flyttOpp()" data-testid="flytt-opp">arrow_drop_up</mat-icon>
        <mat-icon fontSet="ion-navicon" class="mat-icon--ionic-ikon dra" (click.stopp)="null" data-testid="dar-og-slipp"/>
        <mat-icon class="ned" (click.stopp)="flyttNed()" data-testid="flytt-ned">arrow_drop_down</mat-icon>
      </div>
    }
  </div>
</ng-template>

<ng-template #tidFragment>
  <div class="tid">
    <tittel-verdi-samling stil="horisontal--en-linje" class="startklokkeslett" [matTooltip]="hjelpetekstTidspunkt()">
      @if (!tidspunkt().ingenVarigheterSatt || sorteringAktivert()) {
        @if (kompakt() && (tidspunkt().start || tidspunkt().varighetAngitt || tidspunkt().varighetBeregnet)) {
          <tittel-verdi stil="horisontal--en-linje" data-testid="start">
            <tittel>
              <mat-icon fontSet="ion-ios-clock-outline" class="mat-icon--ionic-ikon"/>
            </tittel>
            <verdi>
              @if (tidspunkt().start) {
                <span class="tidspunkt">{{ tidspunkt().start | zoneddatetimeSomPlainTime | plaintime }}</span>
              }
              @if (tidspunkt().varighetAngitt || tidspunkt().varighetBeregnet) {
                <span class="varighet">{{ tidspunkt().varighet | duration: 'timerMinutterKort' }}</span>
              }
            </verdi>
          </tittel-verdi>
        } @else {
          <!--på flerdagsmøter hvor ikke alle saker har varighet satt vil start ikke nødvendigvis være satt-->
          @if (tidspunkt().start) {
            <tittel-verdi [verdi]="tidspunkt().start | zoneddatetimeSomPlainTime | plaintime" stil="horisontal--en-linje" data-testid="start">
              <tittel>
                <mat-icon fontSet="ion-ios-clock-outline" class="mat-icon--ionic-ikon"/>
              </tittel>
            </tittel-verdi>
          }
          <!--på flerdagsmøter vil ikke saker uten varighet får denne beregnet-->
          @if (tidspunkt().varighetAngitt || tidspunkt().varighetBeregnet || sorteringAktivert()) {
            <tittel-verdi class="varighet" stil="horisontal--en-linje" data-testid="varighet">
              <tittel>
                <mat-icon fontSet="ion-ios-stopwatch-outline" class="mat-icon--ionic-ikon"/>
              </tittel>
              <verdi>
                @if (sorteringAktivert() && varighetKontroll() != null) {
                  <varighet-minutter-velger [skjemakontroll]="varighetKontroll()!" placeholder="{{'Varighet'|translate}}"/>
                } @else {
                  {{ tidspunkt().varighet | duration }}
                }
              </verdi>
            </tittel-verdi>
          }
        }
      }
    </tittel-verdi-samling>
  </div>
</ng-template>
